export default "__VITE_PUBLIC_ASSET__73be4e76__"